"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var alt_1 = require("../../alt");
var categories_actions_1 = require("../actions/categories_actions");
var CategoriesStore = /** @class */ (function () {
    function CategoriesStore() {
        this.state = {
            categories: [],
        };
        this.bindListeners({
            handleLoaded: categories_actions_1.default.LOADED,
        });
    }
    CategoriesStore.prototype.handleLoaded = function (response) {
        this.setState({ categories: response.categories });
    };
    return CategoriesStore;
}());
exports.default = alt_1.default.createStore(CategoriesStore, 'CategoriesStore');
//# sourceMappingURL=categories_store.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/stores/categories_store.js
// module id = 4xgS
// module chunks = 20 21